// Single source of truth for local SEO landing pages.
// Each entry renders at /heat-pump-installation-{slug}

export const locations = [
  {
    slug: "burlington-ma",
    town: "Burlington",
    state: "MA",
    stateFull: "Massachusetts",
    county: "Middlesex County",
    region: "Greater Boston (Route 128 corridor)",
    utility: "National Grid",
    rebateProgram: "Mass Save",
    title: "Heat Pump Installation in Burlington, MA | Online Pricing & Rebates",
    description:
      "Get heat pump and ductless mini split installation pricing online in Burlington, MA. Transparent quotes, Mass Save rebates, and financing — no sales visits required.",
    intro: [
      "Burlington homeowners are switching to cold climate heat pumps to cut heating costs and add efficient summer cooling. We make it simple to get transparent heat pump installation pricing online — before anyone steps inside your home.",
      "Whether you're replacing an aging furnace, adding a ductless mini split, or upgrading central air, you'll see recommended equipment, pricing, and financing tailored to your Burlington home.",
    ],
    localNotes: [
      "Sized for Burlington's mix of mid-century ranches, colonials, and newer construction near the Route 128 / I-95 corridor.",
      "Cold climate heat pumps are rated to perform through New England winters, including sub-zero stretches.",
      "Eligible homeowners can stack Mass Save rebates and federal tax credits to lower upfront cost.",
    ],
    nearby: ["Woburn", "Bedford", "Lexington", "Billerica", "Wilmington"],
  },
  {
    slug: "lexington-ma",
    town: "Lexington",
    state: "MA",
    stateFull: "Massachusetts",
    county: "Middlesex County",
    region: "Greater Boston",
    utility: "Eversource",
    rebateProgram: "Mass Save",
    title: "Heat Pump Installation in Lexington, MA | Online Pricing & Rebates",
    description:
      "Heat pump and ductless mini split installation pricing online for Lexington, MA homeowners. Transparent quotes, Mass Save rebates, and flexible financing — no high-pressure sales visits.",
    intro: [
      "From historic homes near the Battle Green to modern builds throughout Lexington, more homeowners are choosing energy-efficient heat pumps for year-round comfort. Get your price online in minutes.",
      "We recommend the right cold climate heat pump or ductless mini split for your home and show transparent pricing, rebates, and financing up front.",
    ],
    localNotes: [
      "Experienced with Lexington's older, character homes where ductless mini split installation preserves architecture.",
      "Designed for New England winters with cold climate performance and efficient summer cooling.",
      "Mass Save rebates and federal incentives applied to your estimate where eligible.",
    ],
    nearby: ["Arlington", "Belmont", "Bedford", "Waltham", "Winchester"],
  },
  {
    slug: "waltham-ma",
    town: "Waltham",
    state: "MA",
    stateFull: "Massachusetts",
    county: "Middlesex County",
    region: "Greater Boston (Charles River)",
    utility: "Eversource",
    rebateProgram: "Mass Save",
    title: "Heat Pump Installation in Waltham, MA | Online Pricing & Rebates",
    description:
      "Get online heat pump and ductless mini split installation pricing in Waltham, MA. Transparent quotes, Mass Save rebates, and financing — skip the in-home sales pitch.",
    intro: [
      "Waltham homeowners along the Charles River and beyond are upgrading to heat pumps for lower heating bills and cleaner, efficient comfort. See your transparent price online today.",
      "Get equipment recommendations, pricing, financing options, and installation scheduling for your Waltham home — all online.",
    ],
    localNotes: [
      "Solutions for Waltham two- and three-family homes, condos, and single-family properties.",
      "Cold climate heat pumps engineered for reliable heat through Massachusetts winters.",
      "Eligible projects include Mass Save rebates and federal tax credits in the estimate.",
    ],
    nearby: ["Watertown", "Newton", "Belmont", "Lexington", "Weston"],
  },
  {
    slug: "wellesley-ma",
    town: "Wellesley",
    state: "MA",
    stateFull: "Massachusetts",
    county: "Norfolk County",
    region: "MetroWest Boston",
    utility: "Wellesley Municipal Light Plant",
    rebateProgram: "Mass Save & WMLP incentives",
    title: "Heat Pump Installation in Wellesley, MA | Online Pricing & Rebates",
    description:
      "Heat pump and ductless mini split installation pricing online for Wellesley, MA. Transparent quotes, available rebates, and financing — no sales visits needed.",
    intro: [
      "Wellesley homeowners value comfort and efficiency. Our platform makes it easy to get transparent heat pump installation pricing online for your home — no surprise quotes.",
      "We match the right cold climate heat pump or ductless mini split to your property and show pricing, incentives, and financing clearly.",
    ],
    localNotes: [
      "Tailored to Wellesley's larger single-family homes that often need multi-zone heating and cooling.",
      "High-performance cold climate systems built for full New England winters.",
      "Wellesley is served by its municipal light plant; we help identify applicable utility and federal incentives.",
    ],
    nearby: ["Needham", "Natick", "Newton", "Dover", "Weston"],
  },
  {
    slug: "natick-ma",
    town: "Natick",
    state: "MA",
    stateFull: "Massachusetts",
    county: "Middlesex County",
    region: "MetroWest Boston",
    utility: "Eversource",
    rebateProgram: "Mass Save",
    title: "Heat Pump Installation in Natick, MA | Online Pricing & Rebates",
    description:
      "Get heat pump and ductless mini split installation pricing online in Natick, MA. Transparent quotes, Mass Save rebates, and financing — no in-home sales visits.",
    intro: [
      "Natick homeowners are moving to efficient cold climate heat pumps for lower heating bills and reliable summer cooling. Get your transparent installation price online in minutes.",
      "We match the right heat pump or ductless mini split to your Natick home and show pricing, rebates, and financing clearly — before anyone visits.",
    ],
    localNotes: [
      "Right-sized for Natick's mix of colonials, capes, and newer MetroWest homes.",
      "Cold climate heat pumps rated for reliable heat through Massachusetts winters.",
      "Mass Save rebates and federal tax credits applied to eligible estimates.",
    ],
    nearby: ["Framingham", "Wellesley", "Wayland", "Sherborn", "Dover"],
  },
  {
    slug: "needham-ma",
    town: "Needham",
    state: "MA",
    stateFull: "Massachusetts",
    county: "Norfolk County",
    region: "Greater Boston",
    utility: "Eversource",
    rebateProgram: "Mass Save",
    title: "Heat Pump Installation in Needham, MA | Online Pricing & Rebates",
    description:
      "Get heat pump and ductless mini split installation pricing online in Needham, MA. Transparent quotes, Mass Save rebates, and financing — without the in-home sales process.",
    intro: [
      "Needham homeowners are replacing oil and gas systems with efficient heat pumps for lower bills and whole-home comfort. Get your transparent price online in minutes.",
      "See recommended equipment, pricing, rebates, and financing for your Needham home — all before anyone visits.",
    ],
    localNotes: [
      "Right-sized for Needham colonials, capes, and renovated homes near the Charles River.",
      "Cold climate heat pumps deliver dependable heat through Massachusetts winters plus summer cooling.",
      "Mass Save rebates and federal tax credits factored into eligible estimates.",
    ],
    nearby: ["Wellesley", "Newton", "Dedham", "Dover", "Westwood"],
  },
  {
    slug: "norwood-ma",
    town: "Norwood",
    state: "MA",
    stateFull: "Massachusetts",
    county: "Norfolk County",
    region: "Greater Boston (South)",
    utility: "Norwood Municipal Light Department",
    rebateProgram: "Utility & federal incentives",
    title: "Heat Pump Installation in Norwood, MA | Online Pricing & Rebates",
    description:
      "Heat pump and ductless mini split installation pricing online for Norwood, MA homeowners. Transparent quotes, available rebates, and financing — no sales visits.",
    intro: [
      "Norwood homeowners are upgrading to energy-efficient heat pumps for comfort and savings. Our online platform gives you transparent installation pricing fast.",
      "Get equipment recommendations, pricing, financing, and scheduling for your Norwood home — entirely online.",
    ],
    localNotes: [
      "Designed for Norwood's single- and multi-family homes south of Boston.",
      "Cold climate heat pumps rated for reliable New England winter heating.",
      "Norwood has its own municipal light department; we help identify utility and federal incentives that apply.",
    ],
    nearby: ["Westwood", "Walpole", "Dedham", "Canton", "Sharon"],
  },
  {
    slug: "north-conway-nh",
    town: "North Conway",
    state: "NH",
    stateFull: "New Hampshire",
    county: "Carroll County",
    region: "Mount Washington Valley",
    utility: "Eversource NH",
    rebateProgram: "NHSaves",
    title: "Heat Pump Installation in North Conway, NH | Online Pricing & Rebates",
    description:
      "Get heat pump and ductless mini split installation pricing online in North Conway, NH. Cold climate systems built for the Mount Washington Valley, with NHSaves rebates and financing.",
    intro: [
      "In the Mount Washington Valley, winters are serious — and so is the case for a properly sized cold climate heat pump. North Conway homeowners can now get transparent installation pricing online.",
      "We recommend cold climate heat pumps and ductless mini splits that perform in deep New Hampshire cold, and show pricing, NHSaves rebates, and financing up front.",
    ],
    localNotes: [
      "Engineered for Mount Washington Valley winters with cold climate heat pumps rated for sub-zero performance.",
      "Great for North Conway homes, cabins, and rentals that need efficient heating and summer cooling.",
      "NHSaves rebates and federal tax credits applied to eligible estimates.",
    ],
    nearby: ["Conway", "Bartlett", "Jackson", "Glen", "Intervale"],
  },
  {
    slug: "bartlett-nh",
    town: "Bartlett",
    state: "NH",
    stateFull: "New Hampshire",
    county: "Carroll County",
    region: "Mount Washington Valley",
    utility: "Eversource NH",
    rebateProgram: "NHSaves",
    title: "Heat Pump Installation in Bartlett, NH | Online Pricing & Rebates",
    description:
      "Get heat pump and ductless mini split installation pricing online in Bartlett, NH. Cold climate systems built for the Mount Washington Valley, with NHSaves rebates and financing.",
    intro: [
      "Bartlett and the surrounding Mount Washington Valley see long, cold winters — making a properly sized cold climate heat pump a smart upgrade. Get transparent installation pricing online.",
      "We recommend cold climate heat pumps and ductless mini splits that perform in deep New Hampshire cold, with pricing, NHSaves rebates, and financing shown up front.",
    ],
    localNotes: [
      "Engineered for Mount Washington Valley winters with sub-zero-rated cold climate heat pumps.",
      "Ideal for Bartlett homes, ski-country cabins, and rental properties needing heat plus summer cooling.",
      "NHSaves rebates and federal tax credits applied to eligible estimates.",
    ],
    nearby: ["North Conway", "Glen", "Jackson", "Intervale", "Conway"],
  },
];

export const getLocation = (slug) => locations.find((l) => l.slug === slug);
